import { CoreExecutorResult, } from "../../core/index.js";
import { PimExecutorResultFactory, loadPimSchema } from "./pim-executor-utils.js";
import { PimAssociationEnd, PimAttribute, PimClass } from "../model/index.js";
export async function executePimDeleteClass(reader, createNewIdentifier, operation) {
    const resource = await reader.readResource(operation.pimClass);
    if (resource === null) {
        return PimExecutorResultFactory.missing(operation.pimClass);
    }
    if (!PimClass.is(resource)) {
        return PimExecutorResultFactory.invalidType(resource, "pim:class");
    }
    if (await isClassUsed(reader, operation.pimClass)) {
        return CoreExecutorResult.createError("Class is used.");
    }
    const schema = await loadPimSchema(reader);
    if (schema === null) {
        return PimExecutorResultFactory.missingSchema();
    }
    return CoreExecutorResult.createSuccess([], [
        {
            ...schema,
            pimParts: schema.pimParts.filter((iri) => iri !== operation.pimClass),
        },
    ], [operation.pimClass]);
}
async function isClassUsed(modelReader, classIri) {
    for (const iri of await modelReader.listResources()) {
        const resource = await modelReader.readResource(iri);
        if (PimAttribute.is(resource)) {
            if (resource.pimOwnerClass === classIri) {
                return true;
            }
        }
        else if (PimAssociationEnd.is(resource)) {
            if (resource.pimPart === classIri) {
                return true;
            }
        }
    }
    return false;
}
//# sourceMappingURL=pim-delete-class-executor.js.map